<template>
    <div class="main-layout-section admin-portal secondary">
        <AdminHeader 
        @setPodData="setPodData($event)" />
        
        <div class="w-logo mb-3">
            <img :src="logo_file" alt="logo" class="w-input-fields animate__animated animate__fadeIn animate__fast" v-if="logo_file !== '' && logo_file !== null"/>
        </div>

        <div class="main-content">
            <h3 class="page-subheading mb-3 animate__animated animate__fadeIn animate__fast">Edit Recurring Reservation</h3>

            <div class="col-md-11 mx-auto">

                <div class="admin-general-section">
                    <div class="admin-general-section-buttons">
                        <router-link :to="`/admin/reservations`" class="admin-general-section-button">
                            Back To Reservations Management
                        </router-link>
                    </div>
                </div>

                <div class="row m-0 p-0 col-md-12 col-sm-12 m-auto">
                    <!-- start of pod form -->
                    <b-form inline @submit.stop.prevent class="m-0 p-0">

                        <div
                        class="
                        w-form-control
                        animate__animated animate__fadeIn animate__fast m-0 p-0
                        " 
                        v-if="lab_reservation_status == 0"
                        >
                            <p class="text-default mt-3 mb-0">This lab has no associated reservation email address. You must return to the Lab Edit page and enter one there before continuing.</p>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Group Name</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.group_name.$error }">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <b-form-input
                                        v-model="form.group_name"
                                        id="rss-url"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0 h-53"
                                        :class="{ 'is-invalid': $v.form.group_name.$error }"
                                        placeholder="Enter group name"
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Select Lab</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.lab_id.$error }">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <b-form-select
                                        v-model="form.lab_id"
                                        :options="labs"
                                        text-field="value"
                                        value-field="id"
                                        id="lab_id"
                                        class="" 
                                        @change="podsByLab"
                                        :class="[ $v.form.lab_id.$error ? 'is-invalid' : '', form.lab_id == '' ? 'text-grey' : '' ]"
                                        placeholder="Select a lab"
                                    ></b-form-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Select Pods</label>
                                <div class="pods-list-container animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.pods_list.$error }">
                                    <div v-if="pods.length > 0" class="w-100">
                                        <span>Select All</span>
                                        <label class="gen-switch tickcross">
                                            <input type="checkbox" 
                                            ref="select_all_pods" 
                                            @change="handleSelectPods('all')"
                                            >
                                            <span class="gen-switch-slider gen-switch-round tickcross"></span>
                                        </label>
                                    </div>

                                    <div v-for="pod in pods" :key="pod.id">
                                        <span>{{pod.license}}</span>
                                        <label class="gen-switch tickcross">
                                            <input type="checkbox" 
                                            :ref="pod.pod_id_key+'_select_pod'" 
                                            :class="pod.id+'-pod-id'"
                                            :checked="selected_pods.indexOf(pod.pod_id_key) !== -1" 
                                            @change="handleSelectPods('', pod.pod_id_key, pod.pod_id_key+'_select_pod')"
                                            >
                                            <span class="gen-switch-slider gen-switch-round tickcross"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row mb-2">
                            <div class="d-flex mb-1 col-md-6 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Start Time</label>
                                <b-input-group class="timepicker-schedule animate__animated animate__fadeIn animate__fast">
                                    <b-input-group-append>
                                        <b-form-timepicker
                                        button-only 
                                        dropup 
                                        left 
                                        @context="(ctx) => startContext(ctx)"
                                        ></b-form-timepicker>
                                    </b-input-group-append>
                                    <b-form-input
                                        v-model="form.start_time"
                                        type="text"
                                        placeholder="HH:mm AM/PM" 
                                        class="w-form-control w-input-fields mb-0" 
                                        :class="{ 'is_invalid': $v.form.start_time.$error }" 
                                        v-mask="'?##:## AA'"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                            <div class="d-flex mb-1 col-md-6 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">End Time</label>
                                <b-input-group class="timepicker-schedule animate__animated animate__fadeIn animate__fast">
                                    <b-input-group-append>
                                        <b-form-timepicker
                                        button-only 
                                        dropup 
                                        left 
                                        @context="(ctx) => endContext(ctx)"
                                        ></b-form-timepicker>
                                    </b-input-group-append>
                                    <b-form-input
                                        v-model="form.end_time"
                                        type="text"
                                        placeholder="HH:mm AM/PM" 
                                        class="w-form-control w-input-fields mb-0" 
                                        :class="{ 'is_invalid': $v.form.end_time.$error }" 
                                        v-mask="'?##:## AA'"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>

                        <div class="col-md-12 mx-auto calendar-wrapper mb-4">
                            <FullCalendar 
                                ref="fullCalendar"
                                :options="calendarOptions"
                            />

                            <div class="row mt-4">
                                <div class="d-flex mb-1 col-md-12 flex-column">
                                    <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Auto-Select Days in Date Range</label>
                                </div>
                                <div class="d-flex mb-1 col-md-6 flex-column">
                                    <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100">
                                        <span><i class="fa-solid fa-file"></i></span>
                                        <input
                                            type="text"
                                            value=""
                                            placeholder="MM/DD/YYYY"
                                            v-model="recurring.start" 
                                            v-mask="date_mask"
                                        />
                                    </div>
                                </div>
                                <div class="d-flex mb-1 col-md-6 flex-column">
                                    <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100">
                                        <span><i class="fa-solid fa-file"></i></span>
                                        <input
                                            type="text"
                                            value=""
                                            placeholder="MM/DD/YYYY"
                                            v-model="recurring.end" 
                                            v-mask="date_mask"
                                        />
                                    </div>
                                </div>
                                <div class="d-flex col-md-9 weekday-selector">
                                    <label v-for="d in weekdays" :key="d.value" class="day-pill">
                                        <input type="checkbox" :value="d.value" v-model="recurring.days" />
                                        <span>{{ d.label }}</span>
                                    </label>
                                </div>
                                <div class="d-flex col-md-3">
                                    <div
                                    class="
                                    w-form-control buttons-container 
                                    animate__animated animate__fadeIn animate__fast m-0 p-0 w-100
                                    ">
                                        <button type="button" class="flex-fill m-0" @click="applyRecurring">
                                            <b-icon class="icon" icon="plus-circle-fill"></b-icon>
                                            Apply to Calendar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">List of Authorized User Accounts</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.emails_list.$error }">
                                    <b-form-textarea
                                        v-model="form.emails_list"
                                        id="note"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0 w-textarea"
                                        :class="{ 'is-invalid': $v.form.emails_list.$error }"
                                        placeholder="Emails List"
                                        no-resize
                                    ></b-form-textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Price</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.price.$error }">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <b-form-input
                                        v-model="form.price"
                                        id="price"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0 h-53"
                                        :class="{ 'is-invalid': $v.form.price.$error }"
                                        placeholder="Enter price"
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="d-flex mb-1 col-md-12 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeIn animate__fast w-100">Notes</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeIn animate__fast w-100" :class="{ 'is_invalid': $v.form.notes.$error }">
                                    <b-form-textarea
                                        v-model="form.notes"
                                        id="notes"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0 w-textarea"
                                        :class="{ 'is-invalid': $v.form.notes.$error }"
                                        placeholder="Notes"
                                        no-resize
                                    ></b-form-textarea>
                                </div>
                            </div>
                        </div>

                        <div
                        class="
                        w-form-control
                        animate__animated animate__fadeIn animate__fast m-0 p-0
                        " 
                        v-if="lab_reservation_status == -1 || lab_reservation_status == 1"
                        >
                            <a
                            href="javascript:void(0)"
                            @click="handleReservationReq"
                            class="flex-fill"
                            >Save</a
                            >
                            <!-- delete button -->
                            <a 
                            href="javascript:void(0)" 
                            v-if="is_valid_reservation"
                            class="flex-fill" 
                            @click="confirmRecurringDelete"
                            >
                            <b-icon class="icon" icon="trash2-fill"></b-icon>
                            Delete
                            </a>
                        </div>
                    </b-form>
                    <!-- end of pod form -->
                </div>

                <h3 class="page-heading mb-3 animate__animated animate__fadeInUp animate__delay-1s mt-5 text-left">Reservation Passcode</h3>
                <div class="row m-0 p-0 col-md-12 col-sm-12 m-auto">
                    
                    <b-form inline @submit.stop.prevent class="m-0 p-0">
                        <!-- client and labe name field -->
                        
                        <div class="row mac-search mt-3">
                            <div class="d-flex mb-1 col-md-3 flex-column">
                                <label for="" class="form-main-label animate__animated animate__fadeInUp animate__delay-2s w-100">Passcode</label>
                                <div class="w-form-control w-input-fields animate__animated animate__fadeInUp animate__delay-2s w-100">
                                    <span><i class="fa-solid fa-file"></i></span>
                                    <b-form-input
                                        v-model="passcode"
                                        id="passcode-name"
                                        class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0"
                                        :disabled="true"
                                    ></b-form-input>
                                </div>
                            </div>
                            
                            <div class="d-flex mb-1 col-md-1 flex-column w-auto">
                                <label for="" class="form-main-label w-100">&nbsp;</label>
                                <div
                                class="
                                w-form-control
                                animate__animated animate__fadeInUp animate__delay-3s m-0 p-0
                                "
                                >
                                    <a
                                    href="javascript:void(0)" 
                                    class="flex-fill m-0" 
                                    :disabled="!is_valid_reservation" 
                                    v-if="!passcode_status" 
                                    @click="confirmRegeneratePasscode"
                                    >
                                    <b-icon class="icon" icon="arrow-clockwise"></b-icon> 
                                    Regenerate Passcode
                                    </a>
                                    <a
                                    href="javascript:void(0)" 
                                    class="flex-fill m-0" 
                                    v-if="passcode_status"
                                    >
                                    <b-icon class="icon" icon="arrow-clockwise" animation="spin"></b-icon> 
                                    Regenerating Passcode...
                                    </a>
                                </div>
                            </div>
                        </div>

                    </b-form>

                </div>
                <!-- end of regenerate passcode -->

            </div>

        </div>

        <!-- start of footer section -->
        <div class="col-md-12 mx-auto">
            <AdminFooter type="inner" />
        </div>
        <!-- end of footer section -->
        
        <!-- start of delete confirm specific date modal -->
        <b-modal id="delete-date-modal" dialog-class="admin-portal-modal" header-class="admin-portal-bg secondary px-3 py-2" hide-footer>
            <template #modal-title>
                Confirm
                <b-icon 
                class="icon" 
                icon="question-circle-fill"
                >
                </b-icon> 
            </template>
            <b-overlay :show="false" rounded="lg">
                <div class="d-flex">
                <p>Are you sure you want to permanently delete selected date from recurring reservation?</p>
                </div>
                <div class="d-flex text-center">
                <button
                    type="button"
                    class="modal-button px-5 py-2"
                    @click="deleteRecurringReservationDate"
                >
                    Yes
                </button>
                <button
                    type="button"
                    class="modal-button px-5 py-2 mx-2"
                    @click="$bvModal.hide('delete-date-modal')"
                >
                    No
                </button>
                </div>
            </b-overlay>
        </b-modal>

        <!-- start of delete confirm reservation modal -->
        <b-modal id="delete-main-modal" dialog-class="admin-portal-modal" header-class="admin-portal-bg secondary px-3 py-2" hide-footer>
            <template #modal-title>
                Confirm
                <b-icon 
                class="icon" 
                icon="question-circle-fill"
                >
                </b-icon> 
            </template>
            <b-overlay :show="false" rounded="lg">
                <div class="d-flex">
                <p>Are you sure you want to permanently delete recurring reservation completely?</p>
                </div>
                <div class="d-flex text-center">
                <button
                    type="button"
                    class="modal-button px-5 py-2"
                    @click="deleteRecurringReservationMain"
                >
                    Yes
                </button>
                <button
                    type="button"
                    class="modal-button px-5 py-2 mx-2"
                    @click="$bvModal.hide('delete-main-modal')"
                >
                    No
                </button>
                </div>
            </b-overlay>
        </b-modal>

        <!-- start of regenerate passcode confirm modal -->
        <b-modal id="passcode-modal" dialog-class="admin-portal-modal" header-class="admin-portal-bg secondary px-3 py-2" hide-footer>
            <template #modal-title>
                Confirm
                <b-icon 
                class="icon" 
                icon="question-circle-fill"
                >
                </b-icon> 
            </template>
            <b-overlay :show="false" rounded="lg">
                <div class="d-flex">
                <p>Are you sure you want to regenerate passcode for this Reservation?</p>
                </div>
                <div class="d-flex text-center">
                <button
                    type="button"
                    class="modal-button px-5 py-2"
                    @click="regeneratePasscodeReservation"
                >
                    Yes
                </button>
                <button
                    type="button"
                    class="modal-button px-5 py-2 mx-2"
                    @click="$bvModal.hide('passcode-modal')"
                >
                    No
                </button>
                </div>
            </b-overlay>
        </b-modal>

    </div>
</template>

<script>
import AdminHeader from "@/views/admin/AdminHeader.vue";
import { adminSaveRecurringReservation, adminGetLabsList, adminGetPodsList, adminGetRecurringReservationDetails, adminDeleteRecurringReservationDate, adminDeleteRecurringReservationMain, adminGetReservationsListForCalendar, adminRegeneratePasscodeReservationRecurring } from "../../services/AdminService";
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import { required } from 'vuelidate/lib/validators';
import AdminFooter from "@/views/admin/AdminFooter.vue";
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
    name: "AdminNewREcurringReservation-view",
    components: { AdminHeader, AdminFooter, FullCalendar },
    data() {
        return {
            labs: [],
            pods: [],
            selected_pods: [],
            form: {
                client_id : '',
                lab_id : '',
                pods_list : '',
                emails_list : '',
                group_name : '',
                start_time: '',
                end_time: '',
                schedules: [
                    {
                        start_date: '',
                        start_time: '',
                        end_time: '',
                    }
                ],
                price: 0,
                notes: ''
            },
            date_mask: '##/##/##?#?#',
            lab_reservation_status: -1,
            edit_reservation_id: this.$route.params.reservation_id,
            is_valid_reservation: false,
            original_reservation: [],
            delete_reservation_id: '',
            reservation_data: [],

            // calendar variables
            selectedDates: [],
            events: [],
            currentMonthEvents: [],
            currentSchedules: [],
            calendarOptions: {
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: 'dayGridMonth',   // IMPORTANT (must NOT be empty)
                selectable: true,
                selectMirror: true,
                unselectAuto: true,
                select: this.handleRangeSelect,
                // dateClick: this.handleDateClick,
                events: [],
                datesSet: this.handleDatesSet,
                dayMaxEvents: 4,
                dayMaxEventRows: true,
                expandRows: false,
                moreLinkClick: 'popover',
                eventDisplay: 'block',
                eventDidMount(info) {
                    info.el.setAttribute(
                        'title',
                        info.event.title
                    )
                },
                eventContent: function(arg) {
                    // Use default rendering for all-day events
                    if (arg.event.allDay) {
                        return true;
                    }

                    let start = arg.event.start;
                    let end = arg.event.end;
                    let startTime = start
                    ? start.toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                    : '';

                    let endTime = end
                    ? end.toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                    : '';
                    return {
                        html: `
                        <div class="fc-event-title-custom">
                            <div class="fc-event-title-line">
                                ${arg.event.title}
                            </div>

                            <div class="fc-event-time-line">
                                ${startTime} - ${endTime}
                            </div>
                        </div>`
                    };
                }
            },
            recurring: {
                start: '',
                end: '',
                days: []
            },
            weekdays: [
                { label: 'Sun', value: 0 },
                { label: 'Mon', value: 1 },
                { label: 'Tue', value: 2 },
                { label: 'Wed', value: 3 },
                { label: 'Thu', value: 4 },
                { label: 'Fri', value: 5 },
                { label: 'Sat', value: 6 }
            ],
            calendar_api_state: false,
            calender_api_request: null,
            currentCalendarRange: {
                start: null,
                end: null
            },
            passcode: "",
            passcode_status: false,
        };
    },

    validations: {
        form : {
            lab_id : {required},
            pods_list : {required},
            emails_list : {required:false},
            group_name: {required},
            start_time: {required},
            end_time: {required},
            schedules: {
                required,
                $each: {
                    start_date: {required},
                    start_time: {required},
                    end_time: {required}
                }
            },
            price: {required:false},
            notes: {required:false}
        }
    },

    computed: {
        logo_file() {
            return this.$store.getters.getThemeLogo().logo;
        }
    },

    watch: {
        'form.lab_id'() {
            this.fetchEventsList();
        },
        'form.start_time'() {
            this.syncFormSchedules();
        },
        'form.end_time'() {
            this.syncFormSchedules();
        },
        selected_pods: {
            handler() {
                this.fetchEventsList();
            },
            deep: true
        }
    },

    methods: {
        getReservationDetails() {
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                reservation_id: this.edit_reservation_id
            };
            adminGetRecurringReservationDetails(params).then(response => {
                if(response.status) {
                    this.is_valid_reservation = true;
                    let res_details = response.data.reservation;
                    this.original_reservation = JSON.parse(JSON.stringify(res_details));
                    this.form.lab_id = res_details.lab_id;
                    this.form.emails_list = res_details.emails_list;
                    this.form.pods_list = res_details.pods_list;
                    this.form.group_name = res_details.group_name;
                    this.selected_pods = res_details.pods_list_array;
                    this.form.schedules = res_details.schedules;
                    this.form.start_time = res_details.start_time;
                    this.form.end_time = res_details.stop_time;
                    this.form.price = res_details.price;
                    this.form.notes = res_details.notes;
                    this.currentSchedules = res_details.schedules;
                    this.selectedDates = [];
                    this.form.schedules.forEach((item) => {
                        const cdate = this.formatDateLocal(new Date(item.start_date));
                        this.selectedDates.push(cdate);
                    });
                    this.passcode = res_details.passcode;
                    this.reservation_data = res_details;
                    this.podsByLab();
                    this.syncEvents();
                    this.fetchEventsList();
                }
                else {
                    this.$router.push({ name: "Admin Reservations"});
                }
            });
        },
        
        labsList() {
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id
            };
            adminGetLabsList(params).then(response => {
                this.labs = response.data.labs;
                // add empty option as placeholder
                this.labs.splice(0, 0, {'id' : '', 'value' : 'Select a lab'});
            });
        },

        podsByLab() {
            if(this.original_reservation.lab_id == this.form.lab_id) {
                this.form.pods_list = this.original_reservation.pods_list;
                this.selected_pods = this.original_reservation.pods_list_array;
            }
            else {
                this.form.pods_list = "";
                this.selected_pods = [];
            }

            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id,
                lab_id: this.form.lab_id
            };
            adminGetPodsList(params).then(response => {
                this.pods = response.data.pods;
                this.lab_reservation_status = response.data.lab_reservation_exist;
            });
        },

        handleSelectPods(type="", pod_id, ref_id) {
            let _self = this;
            if(type == "all") {
                this.selected_pods = [];
                if(this.$refs.select_all_pods.checked) {
                    this.pods.forEach((item) => {
                        _self.selected_pods.push(item.pod_id_key);
                    });
                }
            }
            else {
                if(this.$refs[ref_id][0].checked) {
                    this.selected_pods.push(pod_id);
                }
                else {
                    this.selected_pods.splice(this.selected_pods.indexOf(pod_id), 1);
                }
                if(this.pods.length == this.selected_pods.length) {
                    this.$refs.select_all_pods.checked = true;
                }
                else {
                    this.$refs.select_all_pods.checked = false;
                }
            }
            if(this.selected_pods.length > 0) {
                this.form.pods_list = this.selected_pods.join(',');
            }
            else {
                this.form.pods_list = '';
            }
        },

        handleReservationReq() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.makeToast("error", "generic-required-message");
            } 
            else {
                let user_data = JSON.parse(localStorage.user_sess_data);
                let data = this.form;
                let schedules = this.form.schedules;
                data.token = user_data.token;
                data.client_id = user_data.client_id;
                data.edit_id = this.edit_reservation_id;
                data.schedules = data.schedules.map(item => {
                    // const date = new Date(item.start_date);
                    // const year = date.getFullYear();
                    // const month = String(date.getMonth() + 1).padStart(2, '0');
                    // const day = String(date.getDate()).padStart(2, '0');
                    // item.start_date = `${month}/${day}/${year}`;
                    // const [year, month, day] = item.start_date.split('-');
                    // item.start_date = `${month}/${day}/${year}`;
                    return {
                        start_datetime: item.start_date + " " + item.start_time,
                        end_datetime: item.start_date + " " + item.end_time,
                        edit_id: Object.prototype.hasOwnProperty.call(item, "edit_id") ? item.edit_id : ""
                    };
                });

                adminSaveRecurringReservation(data).then(response => {
                    if(response.status){
                        this.makeToast("success", response.message);
                        this.getReservationDetails();
                    } else {
                        this.form.schedules = schedules;
                        this.makeToast("error", response.message);
                    }
                }); 
            }
        },

        makeToast(variant = "default", message) {
            this.$root.$emit("toast_message", {'type' : variant, 'message' : message});
        },

        setPodData(obj) {
            this[obj.key] = obj.value;
        },

        startContext(ctx) {
            if (ctx.minutes >= 0) {
                let ts = ctx.formatted.split(" ");
                if (ts.length > 1 && ts[0].includes(':')) {
                    let ts1 = ts[0].split(":");
                    let ts_final =
                        (ts1[0] < 10 ? '0' + ts1[0] : ts1[0]) +
                        ":" + ts1[1] + " " + ts[1];

                    this.form.start_time = ts_final;
                }
            }
        },
        endContext(ctx) {
            if (ctx.minutes >= 0) {
                let ts = ctx.formatted.split(" ");
                if (ts.length > 1 && ts[0].includes(':')) {
                    let ts1 = ts[0].split(":");
                    let ts_final =
                        (ts1[0] < 10 ? '0' + ts1[0] : ts1[0]) +
                        ":" + ts1[1] + " " + ts[1];

                    this.form.end_time = ts_final;
                }
            }
        },
        // delete reservation single date
        deleteRecurringReservationDate() {
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                schedule_id: this.delete_reservation_id,
                reservation_id: this.edit_reservation_id,
                client_id: user_data.client_id
            };
            adminDeleteRecurringReservationDate(params).then(response => {
                if(response.status) {
                    this.$bvModal.hide('delete-date-modal');
                    this.makeToast("success", response.message);
                    this.getReservationDetails();
                }
                else {
                    this.makeToast("error", response.message);
                }
            });
        },
        // delete main reservation as a full
        confirmRecurringDelete() {
            this.$bvModal.show('delete-main-modal');
        },
        deleteRecurringReservationMain() {
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                reservation_id: this.edit_reservation_id,
                client_id: user_data.client_id
            };
            adminDeleteRecurringReservationMain(params).then(response => {
                if(response.status) {
                    this.$bvModal.hide('delete-main-modal');
                    this.makeToast("success", response.message);
                    setTimeout(() => {
                        this.$router.push({ name: "Admin Reservations" });
                    }, 2000);
                }
                else {
                    this.makeToast("error", response.message);
                }
            });
        },
        // fullcalendar functions
        handleRangeSelect(info) {
            const start = new Date(info.start);
            const end = new Date(info.end);
            let current = new Date(start);
            end.setDate(end.getDate() - 1);
            while (current <= end) {
                const dateStr = this.formatDateLocal(current)
                const index = this.selectedDates.indexOf(dateStr);
                if (index > -1) {
                    this.selectedDates.splice(index, 1)
                } 
                else {
                    this.selectedDates.push(dateStr)
                }
                current.setDate(current.getDate() + 1);
            }

            this.syncEvents();
            // clear selection UI overlay
            this.$refs.fullCalendar.getApi().unselect();
        },
        applyRecurring() {
            if (!this.recurring.start || !this.recurring.end || !this.recurring.days.length) {
                return
            }

            let current = new Date(this.recurring.start)
            const end = new Date(this.recurring.end)

            while (current <= end) {
                const day = current.getDay();
                if (this.recurring.days.includes(day)) {
                    const dateStr = this.formatDateLocal(current);
                    const index = this.selectedDates.indexOf(dateStr);
                    if (index > -1) {
                        this.selectedDates.splice(index, 1);
                    }
                    else {
                        this.selectedDates.push(dateStr);
                    }
                }
                current.setDate(current.getDate() + 1);
            }

            this.syncEvents()
            // reset UI (optional)
            this.recurring = { start: '', end: '', days: [] }
        },
        syncEvents() {
            // fetch selected dates
            const temporary_events = this.selectedDates.map(d => ({
                id: `temp_${d}`,
                start: d,
                allDay: true,
                display: 'background',
                classNames: ['selected-date']
            }));
            const db_events = this.currentMonthEvents || [];
            this.calendarOptions = {
                ...this.calendarOptions,

                events: [
                    ...db_events,
                    ...temporary_events
                ]
            }

            // sync schedules
            this.syncFormSchedules();
        },
        formatDateLocal(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },
        datesSet(info) {
            this.currentCalendarRange = {
                start: info.startStr,
                end: info.endStr
            }
            this.fetchEventsList();
        },
        handleDatesSet(info) {
            this.currentCalendarRange = {
                start: info.startStr,
                end: info.endStr
            }
            this.fetchEventsList();
        },
        async fetchEventsList() {
            if(this.form.lab_id == '' || this.selected_pods.length <= 0 || !this.currentCalendarRange.start) {
                return;
            }
            if(this.calender_api_request) {
                this.calender_api_request.abort();
                this.calender_api_request = null;
            }
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id,
                lab_id: this.form.lab_id,
                pods: this.selected_pods,
                start: this.currentCalendarRange.start,
                end: this.currentCalendarRange.end,
                edit_id: this.edit_reservation_id
            };

            this.calender_api_request = new AbortController();
            this.calendar_api_state = true;
            const response = await adminGetReservationsListForCalendar(
                params,
                this.calender_api_request.signal
            );
            this.calendar_api_state = false;
            this.currentMonthEvents = response.data.reservations;
            this.syncEvents();
        },
        syncFormSchedules() {
            if(this.selectedDates.length <= 0) {
                this.form.schedules = [];
                return;
            }
            if(this.form.start_time == '' || this.form.end_time == '') {
                this.form.schedules = [];
                return;
            }

            // fetch selected dates
            const schedules = this.selectedDates.map(date => {
                // const cdate = new Date(date);
                // const cyear = cdate.getFullYear();
                // const cmonth = String(cdate.getMonth() + 1).padStart(2, '0');
                // const cday = String(cdate.getDate()).padStart(2, '0');
                // date = `${cmonth}/${cday}/${cyear}`;
                const [cyear, cmonth, cday] = date.split('-');
                date = `${cmonth}/${cday}/${cyear}`;
                const existing = this.currentSchedules.find(
                    s => s.start_date === date
                );

                if (existing) {
                    return {
                        start_date: existing.start_date,
                        start_time: this.form.start_time,
                        end_time: this.form.end_time,
                        edit_id: existing.edit_id
                    };
                }

                return {
                    start_date: date,
                    start_time: this.form.start_time,
                    end_time: this.form.end_time,
                    edit_id: ''
                };
            });
            this.form.schedules = schedules;
        },
        confirmRegeneratePasscode() {
            this.$bvModal.show('passcode-modal');
        },
        regeneratePasscodeReservation() {
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                reservation_id: this.edit_reservation_id
            };
            this.passcode_status = true;
            adminRegeneratePasscodeReservationRecurring(params).then(response => {
                this.passcode_status = false;
                if(response.status) {
                    this.$bvModal.hide('passcode-modal');
                    this.makeToast("success", response.message);
                    this.passcode = response.data.passcode;
                }
                else {
                    this.makeToast("error", response.message);
                }
            });
        },
  },

  mounted() {
    this.labsList();
    this.getReservationDetails();
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
        if(modalId == "delete-date-modal") {
            this.delete_reservation_id = "";
        }
    });
  }

};
</script>
<style scoped>
.pods-list-container {
    display: flex;
    flex-direction: row;
    padding: 10px 10px;
    column-gap: 20px;
    background: #d8d8d8;
    margin: 10px 0px;
    border-radius: 8px;
    min-height: 56px;
    flex-wrap: wrap;
    row-gap: 15px;
}
.pods-list-container > div {
    display: flex;
    flex-direction: row;
    width: fit-content;
    color: #191919;
    font-weight: 700;
    align-items: center;
    column-gap: 10px;
}
.admin-portal .input-group > .w-form-control.is_invalid {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
/* start of general switches */
.gen-switch {
    position: relative;
    display: inline-block;
    width: 70px;
    height: 34px;
}
.gen-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
.gen-switch-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #7f7f7f;
    -webkit-transition: .4s;
    transition: .4s;
}  
.gen-switch-slider:before {
    position: absolute;
    content: "";
    height: 40px;
    width: 40px;
    left: 0px;
    bottom: -2px;
    -webkit-transition: .4s;
    transition: .4s;
    background-color: var(--client-hover);
    font-family: "FontAwesome";
    display: flex;
    align-items: center;
    justify-content: center;;
    color: #d8d8d8;
}
.gen-switch input:checked + .gen-switch-slider:before {
    -webkit-transform: translateX(31px);
    -ms-transform: translateX(31px);
    transform: translateX(31px);
    background-color: var(--client-primary);
}
.gen-switch-slider.gen-switch-round {
    border-radius: 34px;
}
.gen-switch-slider.gen-switch-round:before {
    border-radius: 50%;
}
.gen-switch-slider.lockunlock:before {
    content: "\f023";
}
.gen-switch.lockunlock input:checked + .gen-switch-slider.lockunlock:before {
    content: "\f13e";
}
.gen-switch-slider.tickcross:before {
    content: "\f00d";
}
.gen-switch.tickcross input:checked + .gen-switch-slider.tickcross:before {
    content: "\f00c";
}
.gen-switch-slider.playpause:before {
    content: "\f04c";
}
.gen-switch.playpause input:checked + .gen-switch-slider.playpause:before {
    content: "\f04b";
}
/* end of general switches */

/* calendar styles */
:deep(.fc-toolbar) {
  color: #d8d8d8;
  font-family: sans-serif;
}
:deep(.fc .fc-toolbar-title) {
    font-size: 1.50em;
    margin: 0px;
    font-family: sans-serif;
    font-weight: 600;
}
:deep(.fc .fc-today-button) {
    text-transform: capitalize;
    font-family: sans-serif;
    background-color: transparent;
    border: 2px solid #7f7f7f;
}
:deep(.fc .fc-today-button:hover) {
    background-color: var(--client-primary);
    border: 2px solid var(--client-primary);
}
:deep(.fc .fc-prev-button),
:deep(.fc .fc-next-button) {
    background-color: transparent;
    border: 2px solid #7f7f7f;
    color: #d8d8d8;
}
:deep(.fc .fc-prev-button) {
    border-right: 0;
}
:deep(.fc .fc-prev-button:hover),
:deep(.fc .fc-next-button:hover) {
    background-color: var(--client-primary);
    border-color: var(--client-primary);
}
:deep(.fc-col-header) {
    background-color: #7f7f7f;
}
:deep(.fc-col-header .fc-col-header-cell) {
    padding: 0.5em;
}
:deep(.fc-col-header .fc-col-header-cell a) {
    color: #191919;
    text-decoration: none;
}
:deep(.fc-daygrid-body .fc-daygrid-day a) {
    color: #d8d8d8;
    text-decoration: none;
    font-weight: 600;
}
:deep(.fc-theme-standard .fc-scrollgrid) {
    border-color: #d8d8d8;
}
:deep(.fc-theme-standard td), 
:deep(.fc-theme-standard th) {
    border-color: #d8d8d8;
}
:deep(.fc .fc-daygrid-day.fc-day-today) {
    background-color: #19191970;
    opacity: 1;
}
:deep(.fc .fc-daygrid-day.fc-day-today a) {
    color: #d8d8d8;
}
:deep(.fc .fc-daygrid-day .selected-date) {
    background-color: var(--client-primary);
    color: #d8d8d8;
    opacity: 1;
}
:deep(.fc-daygrid-event) {
  border-radius: 6px;
  padding: 2px 6px;
}
:deep(.fc-event-title) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #d8d8d8;
}
:deep(.fc-event-title-custom) {
  overflow: hidden;
  width: 100%;
}
:deep(.fc-event-title-line) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #d8d8d8;
  font-weight: 600;
  font-size: 12px;
  display: block;
}
:deep(.fc-event-time-line) {
  font-size: 11px;
  white-space: nowrap;
}
:deep(.fc-h-event) {
    background-color: transparent;
    border: 1px solid var(--client-primary);
    display: block;
}
:deep(.fc-h-event .fc-event-time) {
    overflow: visible;
}
:deep(.fc-theme-standard .fc-popover) {
    background: #d8d8d8;
    border-color: var(--client-primary);
}
:deep(.fc-theme-standard .fc-popover-header) {
    background: var(--client-primary);
    color: #fff;
}
:deep(.fc-popover-body .fc-h-event) {
    background: var(--client-primary);
}
:deep(.current-reservation-event) {
    background: #3f3f3f;
}
/* checkboxes for recurring  */
.weekday-selector {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.day-pill {
  position: relative;
  cursor: pointer;
  width: calc((100% - 56px) / 7);
}
.day-pill input {
  display: none;
}
.day-pill span {
    display: inline-block;
    padding: 14px 14px;
    border-radius: 8px;
    background: #d8d8d8;
    color: #191919;
    font-weight: 500;
    transition: 0.2s;
    width: 100%;
    text-align: center;
}
/* hover */
.day-pill:hover span {
    background: var(--client-primary);
    color: #d8d8d8;
}
/* checked */
.day-pill input:checked + span {
    background: var(--client-primary);
    color: #d8d8d8;
}
@media screen and (max-width: 425px) {
    .weekday-selector {
        margin-bottom: 10px;
    }
    .day-pill {
        width: calc((100% - 48px) / 7);
    }
    .day-pill span {
        padding: 14px 7px;
    }
}
</style>